export * from './black-friday.models';
